import instance from "@network/api";

export async function endSession() {
  const res = await instance.post("/user/end-session");

  return res.data;
}

export async function getUserReferralInfo() {
  const res = await instance.get("/users/referral-info");

  return res.data;
}